import { render } from "./VacationPanel.vue?vue&type=template&id=4b59ac82&ts=true"
import script from "./VacationPanel.vue?vue&type=script&lang=ts"
export * from "./VacationPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__